module.exports = __webpack_public_path__ + "static/media/general-post-office_0.8e347755.jpg";